import Vue from 'vue';

const bus = new Vue();

export const $emit = (eventName, ...args) => bus.$emit(eventName, ...args);
export const $on = (eventName, cb) => bus.$on(eventName, cb);
export const $off = (eventName, cb) => bus.$off(eventName, cb);
